<template>
    <div>
        <div class="mobile-date-odd text-center table-header-column">
            {{translate('markets', market, language)}}
        </div>
        <div class="display-board" v-for="(sortedOdd, index) in sortedOdds" :key="matchInfo.MatchId+'_'+market+'_'+index">
            <div class="flex">
                <div class="w-50">
                    <div class="handicap">
                        {{translate('handicap', 'First Goal', language)}}
                    </div>
                </div>
                <div class="w-50">
                    <DisplayUpdatedValue
                            :batch="newBatchId"
                            :newOdd="newOddValue(sortedOdd, oddValueAwayFG)"
                            :oldOdd="oldOddValue(sortedOdd, oddValueAwayFG)"/>
                </div>
            </div>
            <div class="flex">
                <div class="w-50">
                    <div class="handicap">
                        {{translate('handicap', 'Last Goal', language)}}
                    </div>
                </div>
                <div class="w-50">
                    <DisplayUpdatedValue
                            :batch="newBatchId"
                            :newOdd="newOddValue(sortedOdd, oddValueAwayLG)"
                            :oldOdd="oldOddValue(sortedOdd, oddValueAwayLG)"/>
                </div>
            </div>
            <div class="flex">
                <div class="w-50">
                    <div class="handicap">
                        {{translate('handicap', 'No Goal', language)}}
                    </div>
                </div>
                <div class="w-50">
                    <DisplayUpdatedValue
                            :batch="newBatchId"
                            :newOdd="newOddValue(sortedOdd, oddNoGoal)"
                            :oldOdd="oldOddValue(sortedOdd, oddNoGoal)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DisplayUpdatedValue from "./DisplayUpdatedValue";
import { sortOdds, formatOdd } from '../../services/FeedService'
import { mapGetters } from 'vuex'
export default {
    name: 'FGLG',
    components: {
        DisplayUpdatedValue
    },
    computed: {
        ...mapGetters({
            index: 'settings/mixParlay',
            language: 'settings/language',
        })
    },
    props: {
        odds : Object,
        matchInfo : [Object, String],
        market: String
    },
    watch: {
        'odds': function() {
            this.initialiseData()
        },
    },
    data() {
        return {
            sortedOdds:[],
            newBatchId: null
        }
    },
    methods :{
        newOddValue(odd, callback) {
            return (odd.new === undefined)? null : callback(odd.new)
        },
        oldOddValue(odd, callback) {
            return (odd.old === undefined)? null : callback(odd.old)
        },
        oddValueAwayFG(odd) {
            return formatOdd(null, odd.OddsData_AwayOddsFG.split('|')[this.index])
        },
        oddValueAwayLG(odd) {
            return formatOdd(null, odd.OddsData_AwayOddsLG.split('|')[this.index])
        },
        oddNoGoal(odd) {
            return formatOdd(null, odd.OddsData_NoGoalOdds.split('|')[this.index])
        },
        initialiseData() {
            if(this.odds){
                let sortedOdds = sortOdds(this.odds)
                this.sortedOdds = sortedOdds.odds
                this.newBatchId = sortedOdds.newBatchId
            }
        }
    },
    created() {
        this.initialiseData()
    }
}
</script>